/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { ApiPromise } from "../models/ApiPromise";
import { axiosCommon } from "../util/axiosSetup";
import { CoordinatesRequest } from "../models/time/CoordinatesRequest";
import { TimeZoneResponse } from "../models/time/TimeZoneResponse";
import Params from "../common/Params";

export default class TimeZoneApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static getTimeZones(): ApiPromise<TimeZoneResponse[]> {
    const url = `${this.baseUrl}/time-zones`;
    return axiosCommon.get(url);
  }

  static transformCoordinates(
    request: CoordinatesRequest
  ): ApiPromise<TimeZoneResponse> {
    const url = `${this.baseUrl}/time-zones?latitude=${request.latitude}&longitude=${request.longitude}`;
    return axiosCommon.get(url);
  }
}
